
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2023-03-03-auth.js",
      function () {
        return require("private-next-pages/blogs/2023-03-03-auth.js/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2023-03-03-auth.js"])
      });
    }
  